import { isDevEnv } from './isDevEnv';

export function logTable(...args) {
  return (isDevEnv() || window.__DN?.DEBUG) && console.table(...args); // eslint-disable-line no-console
}
